import React, {useState, useEffect, Fragment} from 'react'
import {Table, Container, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {Channelselect} from '../channelselect';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {CanvasNavigation} from '../Navigation'
import {Marketlist} from './marketlist'
import {Market} from './market'
import {Markettype} from './markettype'

export default function Eventlist(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    /*const existingStructure = useSelector(({canvas_structure}) => ({
            sport: Object.keys(canvas_structure.sport)
        }));*/

    const channel = (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?props.match.params.channel:null;
    const sport = (typeof props.match.params.sport !== 'undefined' && props.match.params.sport.length > 0)?props.match.params.sport:null;
    const market = (typeof props.match.params.market !== 'undefined' && props.match.params.market.length > 0)?props.match.params.market:null;
    const type = (typeof props.match.params.type !== 'undefined' && props.match.params.type.length > 0)?props.match.params.type:null;

    const sportObj = useSelector(({canvas_structure}) => (typeof canvas_structure.sport[sport] !== 'undefined')?canvas_structure.sport[sport]:null);
    const markets = useSelector(({canvas_structure}) => (typeof canvas_structure.market !== 'undefined')?canvas_structure.market:null);
    const markettypes = useSelector(({canvas_structure}) => (typeof canvas_structure.markettype !== 'undefined')?canvas_structure.markettype:null);
    const outcomes = useSelector(({canvas_structure}) => (typeof canvas_structure.outcome !== 'undefined')?canvas_structure.outcome:null);

    const path = useSelector(({canvas_structure}) => {
        let ret = [];

        if(sport !== null && sportObj !== null)
            ret.push(sportObj)
        /*if(category !== null)
            ret.push(canvas_structure.category[category])
        if(tournament !== null)
            ret.push(canvas_structure.tournament[tournament])*/
        return ret;
    });

    useEffect(() => {
        if(sportObj === null)
            dispatch(StructureActions.load_missing(firestore, channel, 'sport', [], [sport]));
    }, [sport]);

    useEffect(() => {
        if(market !== null)
            dispatch(StructureActions.loadOutcomes(firestore, channel, market));
    }, [market]);

    useEffect(() => {
        if(type !== null){
            dispatch(StructureActions.loadOutcomesByType(firestore, channel, type));
        }
    }, [type]);

    useEffect(() => {
        if(sportObj !== null){
            dispatch(StructureActions.loadMarkets(firestore, channel, sport));
            dispatch(StructureActions.loadMarkettypes(firestore, channel, sport));
        }
    }, [sportObj]);

    return (
        <CanvasNavigation breadcrumb={[
            {
                'caption': 'Struktur',
                'href': 'canvas/structure/'
            },
            ...(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?[{            
                'caption': props.match.params.channel,
                'href': 'canvas/structure/' + props.match.params.channel
            }]:[],
            ...(path.map((p, idx) => {
                let r = [channel];

                for(let i = 0;i <= idx; i++)
                    r.push(path[i].uid);

                return {
                    'caption': (typeof p.name !== 'undefined')
                        ?p.name
                        :(typeof p.canvas !== 'undefined' && typeof p.canvas.name !== 'undefined')
                            ?p.canvas.name
                            :(typeof p.canvas.canvas !== 'undefined')
                                ?p.canvas.canvas.name
                                :p.uid,
                    'href': 'canvas/structure/' + r.join('/')
                }
            })), 
            {
                'caption': 'Märkte',
                'href': 'canvas/markets/' + channel + '/' + sport
            },
            ...(market !== null && typeof markets[market] !== 'undefined' && markets[market] !== null)?[{            
                'caption': (typeof markets[market].name !== 'undefined')
                        ?markets[market].name
                        :(typeof markets[market].canvas !== 'undefined' && typeof markets[market].canvas.name !== 'undefined')
                            ?markets[market].canvas.name
                            :(typeof markets[market].canvas.canvas !== 'undefined')
                                ?markets[market].canvas.canvas.name
                                :markets[market].uid,
                'href': 'canvas/markets/' + props.match.params.channel + '/' + sport + '/market/' + market
            }]:[],
            ...(type !== null)?[{            
                'caption': type,
                'href': 'canvas/markets/' + props.match.params.channel + '/' + sport + '/type/' + type
            }]:[],
        ]}>
            <div>
                <div>
                    {
                        (type !== null)?
                            (outcomes !== null)?
                                <Markettype type={(typeof markettypes[type] === 'undefined')?{uid: type, canvas: {}}:markettypes[type]} outcomes={outcomes} channel={channel} sport={sport} />
                            :null
                        :
                            (market !== null && typeof markets[market] !== 'undefined')?
                                (outcomes !== null)?
                                    <Market market={markets[market]} outcomes={outcomes} channel={channel} sport={sport} />
                                :null
                            :
                                (markets !== null)?
                                    <Marketlist onClickMarket={(market) => {
                                        dispatch(RouterActions.push('canvas/markets/' + channel + '/' + sport + '/market/' + market.uid));
                                    }} onClickType={(market) => {
                                        dispatch(RouterActions.push('canvas/markets/' + channel + '/' + sport + '/type/' + market.canvas.type));
                                    }} markets={markets} />
                                :null
                    }
                </div>
            </div>
        </CanvasNavigation>
    );
}